var site = site || {};

site.favorites = site.favorites || {};

(function ($, prodcat, generic) {
  Drupal.behaviors.productFullWishlistV1 = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      var self = this;
      var $product = $('.js-product-ui', context);
      var $wishList = $('.js-add-to-wishlist.wishlist--default', $product);

      // @todo address accessibility
      // $product.once().on('click keydown', '.js-add-to-wishlist', function(e) {
      //   var keycode = site.getKeycode(e);
      //   if (keycode === 1 || keycode === 13) {
      //     var skuBaseId = $(this).data('sku-base-id');
      //     prodcat.ui.addToFavorites({skuBaseId: skuBaseId, $el: $(this)});
      //   }
      // });
      $wishList.once().on('click', function () {
        var skuBaseId = $(this).data('sku-base-id');

        prodcat.ui.addToWishlist({
          skuBaseId: skuBaseId,
          $el: $(this)
        });
      });

      if (site.favorites.FAVORITE_PRODUCTS && site.favorites.FAVORITE_PRODUCTS.length) {
        self.visualUpdateFavs();
      } else {
        site.favorites.FAVORITE_PRODUCTS = new Array();
        generic.jsonrpc.fetch({
          method: 'user.getFavorites',
          onSuccess: function (jsonRpcResponse) {
            var rpcResponse = jsonRpcResponse.getValue();

            if (rpcResponse && rpcResponse.length)
            {
                var skuProducts = rpcResponse.skus || [];

                if (skuProducts.length) {
                  _.each(skuProducts, function (sku) {
                    if (sku.SKU_ID) {
                      var matchResult = sku.SKU_ID.match('[0-9]+');

                      if (matchResult) {
                        self.addFav(matchResult[0]);
                      }
                    }
                  });
                  self.visualUpdateFavs();
                }
            }
          }
        });
      }
    },

    addFav: function (skuBaseId) {
      site.favorites.FAVORITE_PRODUCTS.push(skuBaseId);
    },

    getFavs: function () {
      return site.favorites.FAVORITE_PRODUCTS;
    },

    visualUpdateFavs: function () {
      var favs = this.getFavs();

      // Display correct text of the CTA Add to Favorites
      if (favs && favs.length) {
        _.each(favs, function (skuBaseId) {
          var selectorString = '.js-add-to-wishlist[data-sku-base-id="' + skuBaseId + '"]';

          $(selectorString).removeClass('wishlist--default wishlist--added').addClass('wishlist--in-wishlist');
        });
      }
    },
    attached: false
  };

  // Update wishlist button sku base id when sku changes.
  $(document).on('product.skuSelect', '.js-product-ui', function (e, skuBaseId) {
    var $product = $(this);
    var $wishSku = $('.js-add-to-wishlist', $product);

    $wishSku.data('sku-base-id', skuBaseId);
    $wishSku.attr('data-sku-base-id', skuBaseId).removeClass('wishlist--added wishlist--in-wishlist').addClass('wishlist--default');
    Drupal.behaviors.productFullWishlistV1.visualUpdateFavs();
  });

  // NOTE we intentionally do not manage removal here - MAC wants that managed on the wishlist itself
  $(document).on('addToWishlist.exists', function (event, cr, $el) {
    // Link to wishlist for already added skus
    $el.removeClass('wishlist--default wishlist--added').addClass('wishlist--in-wishlist');
  });

  $(document).on('addToWishlist.success', function (event, cr, $el) {
    var skuBaseId = $el.data('sku-base-id');

    Drupal.behaviors.productFullWishlistV1.addFav(skuBaseId);
    Drupal.behaviors.productFullWishlistV1.visualUpdateFavs();
  });
})(jQuery, window.prodcat = window.prodcat || {}, window.generic = window.generic || {});
